<div class="main">
   <div  class="block presentation"  style="background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.488), rgba(26, 4, 20, 0.521)),
url(../../../assets/background/Forum/1.jpg) ;    background-size: cover;" >
   <div class="content"  >
<p class="general" data-aos="fade-down" data-aos-duration="1500"  >
    <span><h1>What is the NRW Forum ?</h1></span>
    The NRW’s forum is an event made especially for enterprises to present the company,
    as well as their products in front of more than 400 students coming from different engineering faculties in Tunisia, 
   notably from <span> INSAT,Sup’com, ENIT, ENIM</span> and many more.
   </p>
   </div>
</div>
<div class="component" >
   <img src="../../../assets/background/Forum/2.jpg">
   <p data-aos-duration="1500" data-aos="fade-left" > Students will also get to discover the newest technologies implemented 
      in the diverse enterprises specializing in different fields.</p>
</div>
<div class="componentReverse">
   <img src="../../../assets/background/Forum/3.jpg">
   <p data-aos-duration="1500" data-aos="fade-right">  Students will also have the chance to submit their CVs and resume
      if interested in working in a certain company and get a closer look at the professional life in general.</p>
</div>
<div class="component" >
   <img src="../../../assets/background/Forum/4.jpg">
   <p data-aos-duration="1500" data-aos="fade-left">    Job Interview Simulations will be held for students to know what to expect in the future.Plus a chance to have their resumes reviewed by experts to help them have a well written CV.</p>
</div>
</div>